(function () {
  tinymce.PluginManager.add("accordian", function (editor, url) {
    editor.ui.registry.addButton("accordian", {
      text: "Accordian",
      onAction: function () {
        editor.formatter.register("accordian", {
          name: "accordian",
          title: "Accordian",
          block: "blockquote",
          classes: "accordian",
          wrapper: true
        });

        editor.formatter.apply("accordian");
      }
    });
    editor.ui.registry.addMenuItem("accordian", {
      text: "Accordian",
      context: "quick",
      onAction: function () {
        editor.formatter.register("accordian", {
          name: "accordian",
          title: "Accordian",
          block: "blockquote",
          classes: "accordian",
          wrapper: true
        });

        editor.formatter.apply("accordian");
      }
    });


    // editor.addShortcut(
    //   "ctrl+alt+a",
    //   "Date format",
    //   ["FormatBlock", false, "accordian"],
    //   this
    // );
  });

  tinymce.PluginManager.add("jumparrow", function (editor, url) {
    editor.ui.registry.addButton("jumparrow", {
      text: "Jump",
      onAction: function () {
        editor.execCommand(
          "mceInsertContent",
          false,
          '<span class="fas fa-arrow-down "> </span> '
        );
      }
    });
    editor.ui.registry.addMenuItem("jumparrow", {
      text: "Jump",
      context: "quick",
      onAction: function () {
        editor.execCommand(
          "mceInsertContent",
          false,
          '<span class="fas fa-arrow-down "> </span> '
        );
      }
    });
  });

  tinymce.PluginManager.add("LB", function (editor, url) {
    editor.ui.registry.addButton("LB", {
      text: "LB",
      onAction: function () {
        editor.execCommand(
          "mceInsertContent",
          false,
          '<span class="leftBracket">[</span> '
        );
      }
    });
    editor.ui.registry.addMenuItem("LB", {
      text: "LeftBracket",
      context: "quick",
      onAction: function () {
        editor.execCommand(
          "mceInsertContent",
          false,
          '<span class="leftBracket">[</span> '
        );
      }
    });
  });

  tinymce.PluginManager.add("RB", function (editor, url) {
    editor.ui.registry.addButton("RB", {
      text: "RB",
      onAction: function () {
        editor.execCommand(
          "mceInsertContent",
          false,
          '<span class="rightBracket">]</span> '
        );
      }
    });
    editor.ui.registry.addMenuItem("RB", {
      text: "RightBracket",
      context: "quick",
      onAction: function () {
        editor.execCommand(
          "mceInsertContent",
          false,
          '<span class="rightBracket">]</span> '
        );
      }
    });
  });

  tinymce.PluginManager.add("BL", function (editor, url) {
    editor.ui.registry.addButton("BL", {
      text: "ßL",
      onAction: function () {
        editor.execCommand("mceInsertContent", false, "<span>ß-lactam</span> ");
      }
    });
    editor.ui.registry.addMenuItem("BL", {
      text: "ß-lactam",
      context: "quick",
      onAction: function () {
        editor.execCommand("mceInsertContent", false, "<span>ß-lactam</span> ");
      }
    });
  })

  let table_to_copy = false

  tinymce.PluginManager.add("copytable", function (editor, url) {
    editor.ui.registry.addButton("copytable", {
      text: "T-Copy",
      onAction: function () {
        let current_cursor = editor.selection.getNode()
        let table = $(current_cursor).closest("table");
        table_to_copy = table.clone()
        editor.selection.select(table[0])
      }
    });
    editor.ui.registry.addMenuItem("copytable", {
      text: "TableCopy",
      context: "quick",
      onAction: function () {
        let current_cursor = editor.selection.getNode();
        let table = $(current_cursor).closest("table");
        table_to_copy = table.clone();
        editor.selection.select(table[0]);
      }
    });
  });

  tinymce.PluginManager.add('pastetable', function (editor, url) {
    editor.ui.registry.addButton("pastetable", {
      text: "T-Paste",
      onAction: function () {
        if (table_to_copy) {
          editor.execCommand(
            "mceInsertContent",
            false,
            table_to_copy[0].outerHTML
          );
        }
      }
    });
    editor.ui.registry.addMenuItem("pastetable", {
      text: "TablePaste",
      context: "quick",
      onAction: function () {
        if (table_to_copy) {
          editor.execCommand(
            "mceInsertContent",
            false,
            table_to_copy[0].outerHTML
          );
        }
      }
    });
  });

  tinymce.PluginManager.add('ruler', function (editor, url) {
    editor.ui.registry.addMenuItem("ruler", {
      text: "Ruler",
      context: "quick",
      onAction: function () {
        $(tinymce.activeEditor.getBody()).toggleClass('bg-horiz-stripe')
      }
    })
  });


  tinymce.PluginManager.add('tableindent', function (editor, url) {

    editor.ui.registry.addButton('BInd', {
      text: 'BInda',
      onAction: function () {
        editor.formatter.register('bindent', {
          name: 'bindent',
          title: 'BIndent',
          selector: 'td',
          styles: { paddingLeft: '15px' },
        })

        editor.formatter.apply('bindent')
        // editor.execCommand('mceInsertContent', false, '<span class="rightBracket">]</span> ')
      },
    })
    editor.ui.registry.addMenuItem('BInd', {
      text: 'BracketIndent',
      context: 'quick',
      onAction: function () {
        editor.formatter.register('bindent', {
          name: 'bindent',
          title: 'BIndent',
          selector: 'td',
          styles: { paddingLeft: '15px' },
        })

        editor.formatter.apply('bindent')
        // editor.execCommand('mceInsertContent', false, '<span class="rightBracket">]</span> ')
      },
    })
  })

  // tinymce.PluginManager.add('ultable', function(editor, url) {
  //   editor.ui.registry.addButton("ultable", {
  //     text: "T-under",
  //     onAction: function() {
  //       editor.formatter.apply("Row Border Bottom");
  //       }
  //   })
  //   editor.ui.registry.addMenuItem("ultable", {
  //     text: "T-under",
  //     context: "quick",
  //     onAction: function() {
  //       editor.formatter.apply("Row Border Bottom");
  //     }
  //   })
  // });


  // table striping js.. set th manually
  // let trs = document.querySelectorAll("tr");

  // let rowspancount = 1;
  // // let dark = false
  // let even = 0;
  // for (let i = 0; i < trs.length; i++) {
  //   for (let j = 0; j < trs[i].children.length; j++) {
  //     rowspancount =
  //       trs[i].children[j].getAttribute("rowspan") > 1
  //         ? trs[i].children[j].getAttribute("rowspan")
  //         : rowspancount;

  //     if (even % 2 == 0) {
  //       trs[i].children[j].classList.add("dark");
  //     }
  //   }
  //   rowspancount -= 1;
  //   if (rowspancount == 0) {
  //     even += 1;
  //     rowspancount = 1;
  //   }
  // }
  // tinymce.PluginManager.add('FormatingToolbarButtons', function (editor, url) {
  //   ['pre', 'p', 'code', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].forEach(function (name) {
  //     editor.ui.registry.addButton("style-" + name, {
  //       tooltip: "Toggle " + name,
  //       text: name.toUpperCase(),
  //       onAction: function() {
  //         editor.execCommand("mceToggleFormat", false, name);
  //           // editor.selection.setContent(
  //           //   "<" + name + ">" + editor.selection.getContent() + "</" + name + ">"
  //           // )
  //       }
  //     });
  //   });
  // })

  // try this from tickets workarounds
  // github.com/tinymce/tinymce/issues/3710
  // to see if is fix for our mem leak too
  tinymce.PluginManager.add("workaround3710", function (editor, url) {
    editor.on("init", function (e) {
      let editorDuplicateCount = 0;
      tinymce.each(tinymce.editors, function (k, v) {
        if (editor == k) {
          editorDuplicateCount++;
        }
      });
      while (editorDuplicateCount > 1) {
        for (let i = 0; i < tinymce.editors.length; i++) {
          if (tinymce.editors[i] == editor) {
            tinymce.editors.splice(i, 1);
            // console.log("remove duplicate editor instance from tinymce.editors");
            break;
          }
        }
        editorDuplicateCount--;
      }
    });
  });

})();
